/** @format */

import React, { useEffect } from 'react';
import {
  htmlToCharacterCheck,
  unescapeHtml,
} from '@services/string-transformation-services';
import { Banner } from './rotating-banner-container';
import { startLazyLoad } from '@services/lazy-load';
import Link from '@base-components/buttons';

interface RotatingBannerProps {
  banner: Banner;
}
/**
 * Rotating Banner.
 */
const RotatingBanner = (props: RotatingBannerProps): JSX.Element => {
  const { banner } = props;
  const {
    title,
    subtitle,
    additionalText,
    textAlignment,
    backgroundColor,
    linkText,
    linkUrl,
    bannerImage,
  } = banner;

  const safeTitle: string | null = htmlToCharacterCheck(title);
  const safeSubtitle: string | null = htmlToCharacterCheck(subtitle);
  const safeLinkText: string | null = htmlToCharacterCheck(linkText);
  const safeAdditionalText: string | null = unescapeHtml(additionalText);
  const alignment = textAlignment === 'left' ? 'grid-2-column-reverse' : '';

  /**
   * Lazy load banner image.
   */
  useEffect(() => {
    startLazyLoad();
  }, []);

  /**
   * Render.
   */
  return (
    <div className={`rotating-banner background-${backgroundColor}`}>
      <div className={`container`}>
        <div className={`grid-2-columns`}>
          <div className={`grid-item `}>
            <div
              className={`img-container lazy background-cover`}
              data-background-image={`${bannerImage}?w=720&h=540&crop=true&quality=40`}>
              <div className={`img-ratio-4-3`} />
            </div>
          </div>
          <div className={`grid-item ${alignment}`}>
            <div className="banner-text-container center-vertically">
              <div className={`text-content-header`}>
                {safeTitle && <h2>{safeTitle}</h2>}
                {safeSubtitle && <h3>{safeSubtitle}</h3>}
              </div>
              {safeAdditionalText && (
                <div
                  className={`text-content-description`}
                  dangerouslySetInnerHTML={{ __html: safeAdditionalText }}
                />
              )}
              <div className="link-container">
                <Link
                  classes={`btn-primary`}
                  url={linkUrl}
                  linkText={safeLinkText}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RotatingBanner;
